/*
 * GBAC Bundle Builder: gbac-bundle-builder.js
 * Created 2026-08-21
 *
 * Drives snippets/gbac-bundle-builder.liquid: live total, live tier, and a
 * single multi-line add to cart.
 *
 * THE ONE THING THAT WILL BITE THE NEXT EDITOR, and it is OUR code, not an app.
 * layout/theme.liquid installs a fetch shim (added 2026-08-19) that dedupes
 * Broadcast's add-to-cart against Monster Cart. When Monster Cart is loaded it
 * SWALLOWS every plain fetch POST to /cart/add that carries neither `m=true`
 * (Monster's own) nor `gbac=1`, returning a synthetic 200 {"items":[]} and
 * adding nothing. Reads are untouched, so a swallowed add looks exactly like an
 * empty cart.
 *
 * So we post to '/cart/add.js?gbac=1', the whitelist the Starter Kit button
 * already uses. Do NOT "work around" the shim by borrowing an unpatched fetch
 * from an iframe: that evades the dedupe and Monster Cart adds a second copy of
 * any line it recognizes. Measured 2026-08-21: the iframe route put 5 units in
 * the cart for a 4-item bundle. The whitelist route is the supported one, and
 * the shim calls monster_refresh() for us after a successful add.
 */
(function () {
  'use strict';

  if (window.__gbacBundleBuilderLoaded) return;
  window.__gbacBundleBuilderLoaded = true;

  var ADD_URL = '/cart/add.js?gbac=1';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    amount = parts.join('.');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  function init(root) {
    if (root.__gbbInit) return;
    root.__gbbInit = true;

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var tiers = [
      { qty: 4, pct: parseFloat(root.dataset.tier4 || '30') },
      { qty: 3, pct: parseFloat(root.dataset.tier3 || '25') },
      { qty: 2, pct: parseFloat(root.dataset.tier2 || '15') }
    ];

    /* Set pages ship a second, sticky copy of the button. It is MOVED to
       <body> before use: position:fixed resolves against the nearest
       transformed ancestor, and Broadcast's AOS animations put transforms on
       ancestors of this block, so a bar left in place anchors to the wrong
       box. It arrives `hidden` so a JS failure leaves nothing broken on screen. */
    var sticky = root.querySelector('[data-gbb-sticky]');
    if (sticky) {
      document.body.appendChild(sticky);
      sticky.hidden = false;
    }
    var scopes = sticky ? [root, sticky] : [root];
    function all(sel) {
      var out = [];
      scopes.forEach(function (sc) {
        out = out.concat(Array.prototype.slice.call(sc.querySelectorAll(sel)));
      });
      return out;
    }

    var btns = all('[data-gbb-add]');
    var btn = btns[0];
    var labelEls = all('.gbac-bb__cta-label');
    var summaryEl = root.querySelector('[data-gbb-summary]');
    var errEl = root.querySelector('[data-gbb-error]');
    var wasEls = all('[data-gbb-total-was]');
    var nowEls = all('[data-gbb-total-now]');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-gbb-item]'));
    if (!btn) return;

    function variantSelect(box) {
      var row = box.closest('.gbac-bb__row');
      return row ? row.querySelector('[data-gbb-variant]') : null;
    }
    function rowPrice(box) {
      var sel = variantSelect(box);
      if (sel && sel.selectedOptions.length) return parseInt(sel.selectedOptions[0].dataset.price, 10) || 0;
      return parseInt(box.dataset.price, 10) || 0;
    }
    function rowVariant(box) {
      var sel = variantSelect(box);
      return (sel && sel.value) ? sel.value : box.dataset.variantId;
    }
    function tierFor(count) {
      for (var i = 0; i < tiers.length; i++) if (count >= tiers[i].qty) return tiers[i].pct;
      return 0;
    }

    /* PER-ROW TIER PRICING (added 2026-08-24).
       Deven: the 4-item default "doesn't show the discount of 30% applied to any
       of the 4 items." Only the button total and the summary line moved; every
       row still printed its full list price, so the page showed a discount it
       never attributed to anything.

       The per-row number is safe to print because the live cart really does
       discount LINE BY LINE, not by allocating a cart-level total across lines.
       Measured on the live storefront, this exact 4-item cart
       (catalog/tier-test/perline-2026-08-24.py): every line came back at
       round(price * 0.70) to the cent, each carrying its own
       "30% off eligible items" line discount, and the four lines summed to the
       118.30 the button already showed. So round-per-row here matches the cart
       and still sums to the total; do not "fix" it into a proportional
       allocation with a remainder, which would print a different number than
       the shopper is charged.

       Deselected rows keep their plain price: they are not in the bundle and
       nothing is being taken off them. */
    var priceRows = [];
    (function collectPriceRows() {
      var anchorPrice = root.querySelector('.gbac-bb__row--current [data-gbb-price]');
      if (anchorPrice) {
        priceRows.push({ el: anchorPrice, box: null, orig: anchorPrice.innerHTML });
      }
      boxes.forEach(function (b) {
        var row = b.closest('.gbac-bb__row');
        var el = row ? row.querySelector('[data-gbb-price]') : null;
        if (el) priceRows.push({ el: el, box: b, orig: el.innerHTML });
      });
    })();

    function basePrice(entry) {
      if (!entry.box) return parseInt(btn.dataset.currentPrice, 10) || 0;
      return rowPrice(entry.box);
    }

    function paintRowPrices(pct) {
      priceRows.forEach(function (entry) {
        var inBundle = entry.box ? entry.box.checked : true;
        if (pct <= 0 || !inBundle) { entry.el.innerHTML = entry.orig; return; }
        var base = basePrice(entry);
        var now = Math.round(base * (1 - pct / 100));
        var nowEl = document.createElement('span');
        nowEl.className = 'gbac-bb__price-now';
        nowEl.textContent = formatMoney(now, moneyFormat);
        var wasEl = document.createElement('s');
        wasEl.className = 'gbac-bb__price-was';
        wasEl.textContent = formatMoney(base, moneyFormat);
        var offEl = document.createElement('span');
        offEl.className = 'gbac-bb__price-off';
        offEl.textContent = pct + '% off';
        entry.el.textContent = '';
        entry.el.appendChild(nowEl);
        entry.el.appendChild(wasEl);
        entry.el.appendChild(offEl);
      });
    }

    /* Ladder pieces for one variant. Falls back to 1 if the weights snippet has
       not loaded, which is the old behavior and never over-promises a tier. */
    function piecesFor(variantId) {
      return (typeof window.gbacPiecesFor === 'function')
        ? window.gbacPiecesFor(variantId, 1)
        : 1;
    }

    function recalc() {
      var subtotal = parseInt(btn.dataset.currentPrice, 10) || 0;

      /* TWO DIFFERENT NUMBERS, and conflating them was a bug.
         `selected` is how many things she is adding, and drives the wording.
         `pieces` is what the ladder counts, and drives the percentage.
         They were the same until 2026-08-23, when the Addie Set began counting
         as TWO pieces. On the set page the anchor IS the Set, so a bare set sits
         on the 15% rung already and set-plus-one-recommendation is 25%; counting
         it as one understated every tier on that page and quoted prices higher
         than the cart would actually charge. */
      var selected = 1;
      var pieces = piecesFor(btn.dataset.currentVariant);
      boxes.forEach(function (b) {
        if (b.checked) {
          selected += 1;
          pieces += piecesFor(rowVariant(b));
          subtotal += rowPrice(b);
        }
      });
      var count = selected;

      var pct = tierFor(pieces);
      var now = Math.round(subtotal * (1 - pct / 100));

      paintRowPrices(pct);

      /* "was" is the undiscounted SELLING subtotal, not the sum of compare-at
         prices. That keeps this number identical to what the cart will charge;
         a compare-at total would advertise a saving Shopify never applies. */
      wasEls.forEach(function (el) {
        if (pct > 0) { el.textContent = formatMoney(subtotal, moneyFormat); el.hidden = false; }
        else { el.textContent = ''; el.hidden = true; }
      });
      nowEls.forEach(function (el) { el.textContent = formatMoney(now, moneyFormat); });

      /* With every recommendation deselected this is an ordinary single add,
         so the button says so. Leaving it on "ADD BUNDLE TO CART" promised a
         bundle the customer had just taken apart. */
      labelEls.forEach(function (el) {
        el.textContent = count === 1
          ? (btn.dataset.labelSingle || 'ADD TO CART')
          : (btn.dataset.labelBundle || 'ADD BUNDLE TO CART');
      });

      /* PIECES, not items (changed 2026-08-26, Deven approved). This used to
         read "1 item · save 15%" for a lone Set, defended as literally true:
         one item, and 15% is what the cart charges. It stopped being defensible
         the day the price block above it began printing "Set of 2 pieces" and
         the tier strip began marking ANY 2 PIECES as already earned. Two
         components inches apart were counting the same cart differently, which
         is the exact confusion this whole change set exists to remove. Pieces
         is also the word the ladder itself uses, so the buybox now has one
         vocabulary end to end. */
      var noun = pieces === 1 ? 'piece' : 'pieces';
      summaryEl.textContent = pct > 0
        ? pieces + ' ' + noun + ' · save ' + pct + '%'
        : pieces + ' ' + noun + ' · add one more to start saving';
    }

    function setBusy(b) {
      btns.forEach(function (el) {
        el.disabled = b;
        el.classList.toggle('is-busy', b);
        el.setAttribute('aria-busy', b ? 'true' : 'false');
      });
    }
    function showError(msg) { errEl.textContent = msg; errEl.hidden = false; }

    function addBundle() {
      errEl.hidden = true;
      var items = [{ id: btn.dataset.currentVariant, quantity: 1 }];
      boxes.forEach(function (b) { if (b.checked) items.push({ id: rowVariant(b), quantity: 1 }); });

      setBusy(true);
      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && r.data.description) || 'add failed');
          /* The shim's tell is 200 with an empty items array. If the whitelist
             ever stops matching, say so rather than claiming a success we did
             not get. */
          if (!r.data || !Array.isArray(r.data.items) || r.data.items.length !== items.length) {
            throw new Error('partial add');
          }
          if (typeof window.openCart === 'function') {
            try { window.openCart(); } catch (e) {}
          }
          btns.forEach(function (el) { el.classList.add('is-added'); });
          setTimeout(function () {
            btns.forEach(function (el) { el.classList.remove('is-added'); });
          }, 2000);
        })
        .catch(function () {
          showError('We could not add everything to your cart. Please try again.');
        })
        .then(function () { setBusy(false); });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-gbb-item], [data-gbb-variant]')) recalc();
    });
    btns.forEach(function (el) { el.addEventListener('click', addBundle); });

    recalc();
  }

  function boot() { document.querySelectorAll('gbac-bundle-builder').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('variant:change', boot);
})();
